import { ReactNode } from 'react';
import { Button } from '@mui/material';

import { StyledDropdownButton } from '../../form/index.js';
import ButtonsBar from '../buttons-bar/buttons-bar.js';

interface Props {
    children?: any;
    title?: string;
    icon?: ReactNode;
    className?: string;
    onClose: AnyFunction;
    buttons?: {
        text: string;
        action?: AnyFunction;
        style?: any;
        color?: string;
        disabled?: boolean;
        variant?: string;
        testId?: string;
        href?: string;
        actions?: {
            text: string;
            action?: AnyFunction;
            icon?: string | ReactNode;
            disabled?: boolean;
        }[];
    }[];
}

const Modal: FC<Props> = ({ children, title, icon, onClose, className = '', buttons }) => {
    const btns = buttons?.map((btn, idx) => {
        const variant = btn.color ? 'contained' : btn.variant;

        const sharedProps = {
            className: idx === 0 && buttons.length > 1 ? 'float-start' : '',
            disabled: btn.disabled,
            color: (btn.color as any) ?? 'inherit',
            variant: variant as any,
        };

        if (btn.actions) {
            return <StyledDropdownButton key={idx} {...sharedProps} options={btn.actions} />;
        }

        return (
            <Button
                key={idx}
                component={btn.href ? 'a' : 'button'}
                href={btn.href}
                {...sharedProps}
                style={btn.style}
                onClick={btn.action ?? onClose}
                data-testid={btn.testId}
            >
                {btn.text}
            </Button>
        );
    });

    return (
        <div className={`ls-modal ${className}`}>
            <div className="modal-panel">
                {title ? (
                    <h1>
                        {icon ? (
                            typeof icon === 'string' ? (
                                <img src={icon} alt="" className="modal-header-icon" />
                            ) : (
                                icon
                            )
                        ) : null}
                        {title}
                    </h1>
                ) : null}
                {children}
            </div>
            <ButtonsBar>{btns}</ButtonsBar>
        </div>
    );
};

export default Modal;
